import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  SearchLocationBadgeComponent,
  type SearchLocationBadgeType,
} from '@frontendlib/components/components/search-location-badge/search-location-badge.component';

/**
 * An item's container (project, notebook, folder, calendar, group) as a badge in the detail header. It is the
 * search results' location badge (Johanna, 2026-10-21: the header badge matches the one in search), so a
 * container reads the same in the list and in the detail. It only names the container.
 */
@Component({
  selector: 'app-container-badge',
  templateUrl: './container-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SearchLocationBadgeComponent],
  // The 140px cap sits on the host, so the host is never wider than the badge in it and the badge shrinks with
  // it in a narrow panel.
  host: { class: 'flex max-w-[140px]' },
})
export class ContainerBadgeComponent {
  public readonly title = input.required<string>();
  public readonly type = input.required<SearchLocationBadgeType>();
  /** The container's colour; the search badge uses it for calendars only. */
  public readonly color = input<string | null>();
}
